// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderHorizontalOutlinedSvg from "@fishx/icons-svg/es/asn/BorderHorizontalOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderHorizontalOutlined = function BorderHorizontalOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderHorizontalOutlinedSvg
  }));
};

BorderHorizontalOutlined.displayName = 'BorderHorizontalOutlined';
export default React.forwardRef(BorderHorizontalOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderHorizontalOutlined.js
// module id = 2087
// module chunks = 0